import React, { useState } from 'react';
import {
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Row,
    Col
} from 'reactstrap';
import Breadcrumbs from "../../globals/core/Breadcrumbs/Breadcrumb";
import {FolderList} from "./Folders/FolderList";
import {Folder} from "./Folders/Folder";


export const SHIHRDashboard = () => {

    const [activeTab, setActiveTab] = useState('1');
    const [createFolder, setCreateFolder] = useState(false);
    const [activeFolder, setActiveFolder] = useState();


    const editFolder = (item) => {
        setActiveFolder(item);
        setCreateFolder(!createFolder);
    }

    const doneCreateNewFolder = () => {
        setActiveFolder(null);
        setCreateFolder(!createFolder);
    }

    const createNewFolder = (e) => {
        e.preventDefault();
        setActiveFolder(null);
        setCreateFolder(!createFolder);
    }

    return (

        <div className="content">
            <div className="page-content">
                <div className="container-fluid">
                    <div className="mb-3">
                        <Breadcrumbs title="MAIN" breadcrumbItem="SHI HR" />
                    </div>
                    <div className="row justify-content-around">
                        <div className="col-12">

                            <div>
                                <Nav tabs>
                                    <NavItem>
                                        <NavLink className={activeTab == '1' ? 'active' : ''} onClick={() => setActiveTab('1')}>
                                            Folders
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId="1">
                                        <div className="mb-2 mt-3 d-flex">
                                            <div><button className="dashboardCTA" onClick={(e)=>createNewFolder(e)}>Create Folder</button></div>
                                            <div><button className="dashboardCTL" onClick={()=>setCreateFolder(false)}>Folders List</button></div>
                                        </div>
                                        <Row>{createFolder ? <Folder item={activeFolder} action={doneCreateNewFolder} /> : <FolderList action={editFolder} />}</Row>
                                    </TabPane>
                                </TabContent>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

